import { outletConstants } from '../_constants';

//-- get the list of terms
export function getAllOutlets(state = {}, action) {
  switch (action.type) {
    case outletConstants.OUTLET_LIST_REQUEST:
      return {
        getAllOutlets: false
      };

    case outletConstants.OUTLET_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { getAllOutlets:action.successAction};

    case outletConstants.OUTLET_LIST_FAILURE:
      return {
        getAllOutlets: false,
      };

    default:
      return state
  }
}